export default __webpack_public_path__ + "static/media/IMG0097.6ffb4331.jpg";